

export class JardinTutoria{    
    idJardinPeriodoTutoria:number;
    idEstadoTutoria:number;
    estadoTutoria:string;
    tutor:string;
    fechaInicioTutoria:Date;
    fechaFinTutoria:Date;
    numeroTutoria:number;
    linkZoom:string;
    constructor(){
        this.idJardinPeriodoTutoria = 0;
        this.idEstadoTutoria = 0;
        this.estadoTutoria = "";
        this.tutor = "";
        this.fechaInicioTutoria = null;
        this.fechaFinTutoria = null;
        this.numeroTutoria = 0;
        this.linkZoom = "";
    }
}
            
export class ResponseJardinTutoria{
    payload:JardinTutoria[];

    constructor(){
        this.payload = new Array<JardinTutoria>();
    }
}